import React from 'react';
import ReactDOM from 'react-dom';
import './fonts/Lato-Regular.ttf'
import Modal from 'react-modal';
import App from './App';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);


